import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Menu, MenuItem } from "@mui/material";
import Button from "components/common/Button";
import { useState } from "react";

/**
 * @typedef {{ label: string, onClick: () => void, disabled?: boolean, icon?: React.ReactNode }} DropdownOption
 */

/**
 * @param {{ label: string, options: DropdownOption[], isLoading?: boolean, isDisabled?: boolean }} props
 */
const DropdownButton = ({
  label,
  options,
  isLoading = false,
  isDisabled = false,
}) => {
  const [anchor, setAnchor] = useState(null);

  return (
    <>
      <Button
        onClick={(e) => setAnchor(e.currentTarget)}
        endIcon={<ExpandMoreIcon />}
        isLoading={isLoading}
        isDisabled={isDisabled}
      >
        {label}
      </Button>
      <Menu
        anchorEl={anchor}
        open={Boolean(anchor)}
        onClose={() => setAnchor(null)}
      >
        {options.map((option) => (
          <MenuItem
            key={option.label}
            onClick={() => {
              setAnchor(null);
              option.onClick();
            }}
            disabled={option.disabled}
          >
            {option.icon && (
              <span style={{ marginRight: 8, display: "flex" }}>
                {option.icon}
              </span>
            )}
            {option.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default DropdownButton;
